import { render } from "./ItemSearch.vue?vue&type=template&id=bd6be766&scoped=true"
import script from "./ItemSearch.vue?vue&type=script&lang=js"
export * from "./ItemSearch.vue?vue&type=script&lang=js"

import "./ItemSearch.vue?vue&type=style&index=0&id=bd6be766&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd6be766"]])

export default __exports__